import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

// Define props interface
interface HospitalCardDetailsProps {
  ProviderName?: string;
  Address?: string;
  PhoneNumber?: string;
  FaxNumber?: string;
  EmailAddress?: string;
  ContactName?: string;
}

// Accept props in the component
const HospitalCardDetails: React.FC<HospitalCardDetailsProps> = ({
  ProviderName,
  Address,
  EmailAddress,
  FaxNumber,
  PhoneNumber,
  ContactName,
}) => {
  return (
    <div className="autoSizeContent">
      {/* Stakeholder Name Section */}
      <div>
        <div className="cardTitle d-flex align-items-center">
          <span className="material-icons mx-1 text-secondary">person</span>
          Location
        </div>
        <div className="d-flex align-items-center">
          <strong>{ProviderName}</strong> {/* ✅ Display name dynamically */}
        </div>
      </div>

      {/* Address Section */}
      <div>
        <div className="cardTitle d-flex align-items-center">
          <span className="material-icons me-1 text-secondary">
            account_balance
          </span>
          Address
        </div>
        <Card className="card">
          <Card.Body className="p-2">
            <Card.Text>{Address}</Card.Text>{" "}
            {/* ✅ Display address dynamically */}
          </Card.Body>
        </Card>
      </div>

      {/* Contact Section */}
      <div>
        <div className="cardTitle d-flex align-items-center">
          <span className="material-icons mx-1 text-secondary">
            restart_alt
          </span>
          Communication Details
        </div>
        <Card className="card">
          <Card.Body className="p-2">
            <Card.Text>{ContactName}</Card.Text>
            <Card.Text>{EmailAddress?.replaceAll(",", ", ")}</Card.Text>
            <Card.Text>{PhoneNumber?.replaceAll(",", ", ")}</Card.Text>
            {/* <Card.Text>{FaxNumber?.replaceAll(',', ', ')}</Card.Text> */}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default HospitalCardDetails;
